import { AST, toAST } from '@/helpers/htmlParser'
import { trim } from 'lodash'
import pptxgen from 'pptxgenjs'
import { formatColor } from '@/helpers/formatColorUtils'
import { ratioPx2Pt } from '@/components/PPTDownloadBtn/PPTBox/doPPTExport'
import i18n from '@/i18n'


export const getFontFace1 = () => {
}

export const getFontFace = () => {
  const lng = i18n.language
  // const platform = navigator.platform.toLowerCase()
  if (lng === 'zh') {
    // if (platform.includes('mac')) {
    // return { key: 'pf', name: 'PingFang SC' }
    // }
    // return { key: 'msyh', name: '微软雅黑' } // Default fallback
    return { key: 'lt', name: '方正兰亭黑' } // Default fallback
  }
  if (lng === 'ja') {
    return { key: 'sourceHanSansJp', name: 'Source Han Sans JP' }
  }
  if (lng === 'ko') {
    return { key: 'sourceHanSansKr', name: 'Source Han Sans KR' }
  }
  /** 外文使用字体逻辑 */
  return { key: 'aptos', name: 'aptos' }
}


// 将HTML字符串格式化为pptxgenjs所需的格式
// 核心思路：将HTML字符串按样式分片平铺，每个片段需要继承祖先元素的样式信息，遇到块级元素需要换行
export const formatHTML = (html: string) => {
  const ast = toAST(html)
  let bulletFlag = false
  let orderedBulletNumber: number | undefined
  let indent = 0
  const blockTags = ['div', 'li', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']

  type ListContext = {
    type: 'ol' | 'ul'
    counter: number
  }

  const getAttributeValue = (item: AST, key: string) => {
    if (!('attributes' in item)) return ''
    return item.attributes.find((attr) => attr.key === key)?.value || ''
  }

  const getOrderedListStart = (item: AST) => {
    const start = Number(getAttributeValue(item, 'start'))
    return Number.isFinite(start) && start > 0 ? Math.floor(start) : 1
  }

  const slices: pptxgen.TextProps[] = []
  const parse = (
    obj: AST[],
    baseStyleObj: { [key: string]: string } = {},
    indentLevel = 0,
    listStack: ListContext[] = []
  ) => {
    for (const item of obj) {
      const isBlockTag = 'tagName' in item && blockTags.includes(item.tagName)

      if (isBlockTag && slices.length) {
        const lastSlice = slices[slices.length - 1]
        if (!lastSlice.options) lastSlice.options = {}
        lastSlice.options.breakLine = true
      }

      const styleObj = { ...baseStyleObj }
      const styleAttr =
        'attributes' in item ? item.attributes.find((attr) => attr.key === 'style') : null
      if (styleAttr && styleAttr.value) {
        const styleArr = styleAttr.value.split(';')
        for (const styleItem of styleArr) {
          const [_key, _value] = styleItem.split(': ')
          const [key, value] = [trim(_key), trim(_value)]
          if (key && value) styleObj[key] = value
        }
      }

      let nextListStack = listStack
      if ('tagName' in item) {
        if (item.tagName === 'em') {
          styleObj['font-style'] = 'italic'
        }
        if (item.tagName === 'strong') {
          styleObj['font-weight'] = 'bold'
        }
        if (item.tagName === 'sup') {
          styleObj['vertical-align'] = 'super'
        }
        if (item.tagName === 'sub') {
          styleObj['vertical-align'] = 'sub'
        }
        if (item.tagName === 'a') {
          const attr = item.attributes.find((attr) => attr.key === 'href')
          styleObj['href'] = attr?.value || ''
        }
        if (item.tagName === 'ul') {
          styleObj['list-type'] = 'ul'
          nextListStack = [...listStack, { type: 'ul', counter: 0 }]
        }
        if (item.tagName === 'ol') {
          styleObj['list-type'] = 'ol'
          nextListStack = [...listStack, { type: 'ol', counter: getOrderedListStart(item) - 1 }]
        }
        if (item.tagName === 'li') {
          const currentList = listStack[listStack.length - 1]
          if (currentList?.type === 'ol') {
            currentList.counter += 1
            orderedBulletNumber = currentList.counter
          } else {
            orderedBulletNumber = undefined
          }
          bulletFlag = true
        }
        if (item.tagName === 'p') {
          if ('attributes' in item) {
            const dataIndentAttr = item.attributes.find((attr) => attr.key === 'data-indent')
            if (dataIndentAttr && dataIndentAttr.value) indent = +dataIndentAttr.value
          }
        }
      }

      if ('tagName' in item && item.tagName === 'br') {
        slices.push({ text: '', options: { breakLine: true } })
      } else if ('content' in item) {
        const text = item.content
          .replace(/&nbsp;/g, ' ')
          .replace(/&gt;/g, '>')
          .replace(/&lt;/g, '<')
          .replace(/&amp;/g, '&')
          .replace(/\n/g, '')
        const options: pptxgen.TextPropsOptions = {}

        if (styleObj['font-size']) {
          options.fontSize = parseInt(styleObj['font-size']) / ratioPx2Pt
        }
        if (styleObj['color']) {
          options.color = formatColor(styleObj['color']).color
        }
        if (styleObj['background-color']) {
          options.highlight = formatColor(styleObj['background-color']).color
        }
        if (styleObj['text-decoration-line']) {
          if (styleObj['text-decoration-line'].indexOf('underline') !== -1) {
            options.underline = {
              color: options.color || '#000000',
              style: 'sng',
            }
          }
          if (styleObj['text-decoration-line'].indexOf('line-through') !== -1) {
            options.strike = 'sngStrike'
          }
        }
        if (styleObj['text-decoration']) {
          if (styleObj['text-decoration'].indexOf('underline') !== -1) {
            options.underline = {
              color: options.color || '#000000',
              style: 'sng',
            }
          }
          if (styleObj['text-decoration'].indexOf('line-through') !== -1) {
            options.strike = 'sngStrike'
          }
        }
        if (styleObj['vertical-align']) {
          if (styleObj['vertical-align'] === 'super') options.superscript = true
          if (styleObj['vertical-align'] === 'sub') options.subscript = true
        }
        if (styleObj['text-align']) options.align = styleObj['text-align'] as pptxgen.HAlign
        if (styleObj['font-weight']) options.bold = styleObj['font-weight'] === 'bold'
        if (styleObj['font-style']) options.italic = styleObj['font-style'] === 'italic'
        if (styleObj['font-family']) options.fontFace = getFontFace().name
        // styleObj['font-family']
        if (styleObj['href']) options.hyperlink = { url: styleObj['href'] }

        if (bulletFlag && styleObj['list-type'] === 'ol') {
          options.bullet = {
            type: 'number',
            indent: (options.fontSize || 16) * 1.1,
            ...(orderedBulletNumber ? { numberStartAt: orderedBulletNumber } : {}),
          }
          options.indentLevel = indentLevel
          options.paraSpaceBefore = 0.1
          bulletFlag = false
          orderedBulletNumber = undefined
        }
        if (bulletFlag && styleObj['list-type'] === 'ul') {
          options.bullet = { indent: (options.fontSize || 16) * 1.1, }
          options.indentLevel = indentLevel
          options.paraSpaceBefore = 0.1
          bulletFlag = false
          orderedBulletNumber = undefined
        }
        if (indent) {
          options.indentLevel = indent
          indent = 0
        }

        slices.push({ text, options })
      } else if ('children' in item) {
        parse(
          item.children,
          styleObj,
          ['ul', 'ol'].includes(item.tagName) && item.children.length > 0 ? indentLevel + 1 : indentLevel,
          nextListStack
        )
      }
    }
  }
  parse(ast, {}, 0)

  /*   const newSlices: pptxgen.TextProps[] = []
  let parentBullet = undefined

  for (let i = 1; i < slices.length; i++) {
    const currentSlice = _.cloneDeep(slices[i])
    const nextSlice = _.cloneDeep(slices[i + 1])
    if (currentSlice.options?.bullet) {
      parentBullet = currentSlice.options.bullet
    }
    if (nextSlice.options?.bullet) {
      nextSlice.options.breakLine = true
    }
  }
 */
  // console.log('slices', slices)
  return slices
}
